import { render, staticRenderFns } from "./shopselftlist.vue?vue&type=template&id=0b7ccace&scoped=true"
import script from "./shopselftlist.vue?vue&type=script&lang=js"
export * from "./shopselftlist.vue?vue&type=script&lang=js"
import style0 from "./shopselftlist.vue?vue&type=style&index=0&id=0b7ccace&prod&scoped=true&lang=scss"
import style1 from "./shopselftlist.vue?vue&type=style&index=1&id=0b7ccace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ccace",
  null
  
)

export default component.exports